export default {
  title: 'Tilausmenetelmät',
  paywall: {
    live_title: '{{name}} on käytössä!',
  },
  tabs: {
    general: 'Yleiset',
    pickup: 'Nouto',
    delivery: 'Toimitus',
    room_service: 'Huone-/pöytäpalvelu',
  },
  modals: {
    update_confirmation: {
      title: 'Haluatko varmasti tallentaa uudet muutokset?',
      buttons: {
        confirm: 'Vahvista',
        cancel: 'Peruuta',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Haluatko varmasti poistaa live-tilaukset käytöstä?',
        enable: 'Haluatko varmasti ottaa live-tilaukset käyttöön?',
      },
      buttons: {
        yes: 'Kyllä',
        no: 'Ei',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
